
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import { showModal, showNestedModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import PageTopTitle from "../../shared/PageTopTitle"
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { MdDragIndicator } from "react-icons/md";
import { getAiSubTitleData, updateAiTitleOrder } from "../../../features/aiControl/aiControlSlice"
import SmallSpinner from "../../shared/spinners/SmallSpinner"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 700px;
        max-height: 600px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .content{
            width: 100%;
            padding: 30px;
            padding-top: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            overflow: auto;


            p{
                padding-bottom: 20px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }
        }

        .btn-container{
            width: 100%;
            display: flex;
            justify-content: center;
            gap: 25px;
            height: 90px;
            background-color: ${({theme}) => theme.mainBgColor};
            border-top: 1px solid ${({theme}) => theme.mainBorderColor};
            padding: 15px 0;
        }
    }
`

const ContentContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .list-item{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        border-radius: 10px;
        background-color: ${({theme}) => theme.secondaryBgColor};

        .list-item-content{
            display: flex;
            align-items: center;
            gap: 2px;

            .drag-icon{
                font-size: 1.4rem;
            }

            .title-name{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }
        }   


    }

`


const UpdateAiOrderModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {allTitles, isLoadingUpdateAiTitleOrder} = useSelector(state => state.aiControl)

    const [list, setList] = useState([])

    useEffect(() => {
        setList(allTitles.map(item => {
            return {...item, titleId: item.titleId.toString()}
        }))
    },[])

    const { lockScroll, unlockScroll } = useScrollLock();


    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const onDragEnd = (result) => {
        if (!result.destination) return; // Sürükleme hedefi yoksa
        const reorderedItems = Array.from(list);
        const [movedItem] = reorderedItems.splice(result.source.index, 1); // Öğeyi kaydır
        reorderedItems.splice(result.destination.index, 0, movedItem);
    

        const orderedList = reorderedItems.map((item, i) => {
            return {
                ...item, order: i+1
            }
        })

        setList(orderedList)
      };

      const handleSubmit = () => {
        const orderList = list.map(item => {
            return {
                titleId:item.titleId,
                order: item.order
            }
        })
        dispatch(updateAiTitleOrder(orderList))

      }

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <PageTopTitle title={"Sırala"}/>
        <div className="content">
            <p>{list.length > 0 ? "Başlıkları sürükle bırak yöntemi ile sıralayabilirsiniz." : "Henüz hiç başlık eklenmemiş."} </p>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="ddd">
                    {(provided) => (
                    <ContentContainer {...provided.droppableProps} ref={provided.innerRef}>
                        {list?.map((item, index) => (
                        <Draggable key={item.titleId} draggableId={item.titleId} index={index}>
                            {(provided) => (
                            <div
                                className='list-item'
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                ref={provided.innerRef}
                            >
                                <div className="list-item-content">
                                    <MdDragIndicator className="drag-icon"/>
                                    <div className="title-name">{index+1}. {item.titleName}</div>
                                </div>
                                <Btn handleClick={()=> {dispatch(showNestedModal("aiSubTitleOrder")); dispatch(getAiSubTitleData(item.subTitles))}} color="#E85546" width={"120px"} height="34px" fontSize="12px">Alt Başlıkları Sırala</Btn>
                            </div>
                            )}
                        </Draggable>
                        ))}
                    </ContentContainer>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
        <div className="btn-container">
            <Btn handleClick={handleSubmit} color="#fff" width={"200px"} height="44px" bgColor="#E85546" >{isLoadingUpdateAiTitleOrder ? <SmallSpinner size={"22px"} color={"#fff"} bgColor={"#E85446"}/>   : "Kaydet"}</Btn>
            <Btn handleClick={()=> dispatch(showModal(null))} color="#E85546" width={"200px"} height="44px" >{list.length > 0 ? "Vazgeç" : "Geri Dön"}</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default UpdateAiOrderModal